import { useQuery } from '@tanstack/react-query';
import { fetchReferralSummary } from '../api/referralClient';

export function useReferralSummaryQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['referral', 'summary'],
    queryFn: fetchReferralSummary,
    staleTime: 60 * 1000,
    enabled
  });
}
